import { ChangeEvent } from 'react';

import { Divider, Grid, Typography } from '@mui/material';

import { CustomInput } from 'src/components/CustomInput';

export type BankField = {
    name: keyof IEBankFieldsProps['values'];
    label: string;
    placeholder: string;
    chargeableField?: string;
};

type BankFieldsValues = {
    settlementAccountBic: string;
    settlementAccountIban: string;
    settlementAccountAccountName: string;
    settlementAccountBankName: string;
    chargeableAccountBic: string;
    chargeableAccountIban: string;
    chargeableAccountAccountName: string;
    chargeableAccountBankName: string;
};

type BankFieldsErrors = {
    settlementAccountBic?: string;
    settlementAccountIban?: string;
    settlementAccountAccountName?: string;
    settlementAccountBankName?: string;
    chargeableAccountBic?: string;
    chargeableAccountIban?: string;
    chargeableAccountAccountName?: string;
    chargeableAccountBankName?: string;
};

type IEBankFieldsProps = {
    heading: string;
    bankFields: BankField[];
    values: BankFieldsValues;
    errors: BankFieldsErrors;
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
    setFieldValue: (field: string, value: string) => void;
    settlementAccountSameAsChargeable?: boolean;
    isEditingDisabled?: boolean;
};

const IEBankFields = ({
    heading,
    bankFields,
    values,
    errors,
    setFieldValue,
    handleChange,
    settlementAccountSameAsChargeable,
    isEditingDisabled,
}: IEBankFieldsProps) => {
    return (
        <>
            <Typography fontSize="24px" color="#434341" marginTop="32px" marginBottom="8px">
                {heading}
            </Typography>
            <Divider
                sx={{
                    borderColor: 'warning.main',
                    marginBottom: '32px',
                }}
            />

            <Grid container rowSpacing={2} columnSpacing={2} rowGap={2}>
                {bankFields.map((field) => {
                    return (
                        <Grid item xs={12} lg={6} key={field.name}>
                            <CustomInput
                                name={field.name}
                                label={field.label}
                                placeholder={field.placeholder}
                                onChange={(event) => {
                                    if (settlementAccountSameAsChargeable) {
                                        setFieldValue(field.chargeableField, event.target.value);
                                    }
                                    handleChange(event);
                                }}
                                value={values[field.name]}
                                error={errors[field.name]}
                                disabled={isEditingDisabled}
                            />
                        </Grid>
                    );
                })}
            </Grid>
        </>
    );
};

export default IEBankFields;
